import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class StablesBuildingTileEntity extends TileEntity {
	public static readonly frameName = FrameName.STABLES;
}

export default StablesBuildingTileEntity;
